export default __webpack_public_path__ + "static/media/resurgence.4fed70b3.png";